export default "__VITE_ASSET__B1yg0sjE__"